import { toast } from "react-toastify";
import axios from "axios";
import { getToken } from "../../../services/localStorageServices";
import {
  deleteDataFromApi,
  getDataFromApi,
  GetTenantDetails,
  postDataFromApi,
  putDataFromApi,
  MainUrl,
} from "../../../services/commonServices";
import { getVesselOperation, getTruckOperations, getStackOperations, getRakeOperations, getRakeCollectionActivity, getPlantOperations, getLMSOperationActivity, getActivityCode, getFormatedDate, getPDFFormattedDateWithTime, getActivityName, getCurrentRole } from "../../../services/commonFunction";
import {
  reportConfigGetApi,
  ccCertGetApi,
  reportHeaderFooterCreateApi,
  reportConfigDeleteApi,
  documentDeleteApi,
  folderCreateApi,
  documentCreateApi,
  bulk_cc_update_to_trans_userAPI,
  bulk_ic_update_to_trans_userAPI,
  getReportConfigApi,
  ccCertDeleteApi,
  reportConfigCreateApi,
  reportConfigUpdateApi,
  documentUpdate,
  ccCertPdfApi, truckCSPdfApi, rakeQAPdfApi, truckQAPdfApi, truckQA2PdfApi, stackQAPdfApi, bulkCargoPDF, physicalAnalysisPDF, tmlMoisturePDFApi, opsRakeSVPDFApi, opsStackSVPDFApi,
  masterUploadApi,
  getTruckSealingApi,
  updateTruckSealingApi,
  ccCertWordApi,
  ccUpdateApi,
} from "../../../services/api";
import { getSingleQualityAnalysisData } from "./operations/RakeHandlerOperation";

import { encryptDataForURL, decryptDataForURL } from "../../../utills/useCryptoUtils";
import { downLoadNonLMSCertificatePDFById, getNonLMSDetailsById } from "./OPscertificate/OPSCertificateHandlerFunctions";


export const getReportConfig = async (EditRecordId, EditSubRecordId, configCertStatusRPCID, setFormData, setSequence) => {
  let payload = {
    ji_id: EditRecordId,
    jis_id: EditSubRecordId,
    rpc_id: configCertStatusRPCID,
  };
  let res = await postDataFromApi(reportConfigGetApi, payload);

  if (res?.data.status === 200) {
    setTimeout(() => {
      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          1: {
            ...prevFormData[1],
            rpc_from_date: res.data.data?.report_configuration.rpc_from_date,
            rpc_to_date: res.data.data?.report_configuration.rpc_to_date,
            rpc_is_lot_no: res.data.data?.report_configuration.rpc_is_lot_no
              ? ["Lot Wise"]
              : [],
            rpc_is_smpl_qty: res.data.data?.report_configuration.rpc_is_smpl_qty
              ? ["Sample Quantity"]
              : false,
            rpc_is_total_no: res.data.data?.report_configuration.rpc_is_total_no
              ? ["Total Number"]
              : false,
            rpc_is_qty: res.data.data?.report_configuration.rpc_is_qty
              ? ["Quantity"]
              : false,
            rpc_is_smpl_wghtorunit: res.data.data?.report_configuration
              .rpc_is_smpl_wghtorunit
              ? ["Sample Weight / Unit"]
              : false,
            rpc_is_total_qty: res.data.data?.report_configuration
              .rpc_is_total_qty
              ? ["Quantity Total"]
              : false,
            rpc_is_smpl_mark: res.data.data?.report_configuration
              .rpc_is_smpl_mark
              ? ["Sample Mark"]
              : false,
            rpc_is_smpl_type: res.data.data?.report_configuration
              .rpc_is_smpl_type
              ? ["Sample Type"]
              : false,
            rpc_is_smpl_total: res.data.data?.report_configuration
              .rpc_is_smpl_total
              ? ["Sample Total"]
              : false,
            rpc_is_dos: res.data.data?.report_configuration.rpc_is_dos
              ? ["Date of Sampling"]
              : false,
            rpc_is_wght_avg: res.data.data?.report_configuration.rpc_is_wght_avg
              ? ["Weighted Avg."]
              : false,
            rpc_is_lotwise_wght_avg: res.data.data?.report_configuration.rpc_is_lotwise_wght_avg
              ? ["Weighted Avg."]
              : false,
            rpc_is_lotwise_qty: res.data.data?.report_configuration.rpc_is_lotwise_qty
              ? ["Lot Quantity"]
              : false,
            rpc_is_appendix: res.data.data?.report_configuration.rpc_is_appendix
              ? ["Appendix"]
              : false,
            rpc_is_size_analysis: res.data.data?.report_configuration.rpc_is_size_analysis
              ? ["Size Analysis"]
              : false,
            rpc_is_sample_specs: res.data.data?.report_configuration.rpc_is_sample_specs
              ? ["Sample Specification"]
              : false,
            rpc_is_smpl_spec_lotno: res.data.data?.report_configuration.rpc_is_smpl_spec_lotno
              ? ["Lot No"]
              : false,
            rpc_is_lotwise_qty: res.data.data?.report_configuration.rpc_is_lotwise_qty
              ? ["Lot Quantity"]
              : false,
            rpc_is_lotwise_sample_qty: res.data.data?.report_configuration.rpc_is_lotwise_sample_qty
              ? ["Sample Quantity"]
              : false,
            rpc_is_lotwise_smpl_mark: res.data.data?.report_configuration.rpc_is_lotwise_smpl_mark
              ? ["Client Sample Mark"]
              : false,
            rpc_is_other_config: res.data.data?.report_configuration.rpc_is_other_config
              ? ["Others"]
              : false,
            rpc_is_dual_port: res.data.data?.report_configuration.rpc_is_dual_port
              ? ["Dual Port 2nd"]
              : false,
            rpc_is_dual_port_combined: res.data.data?.report_configuration.rpc_is_dual_port_combined
              ? ["Dual Port Combined"]
              : false,
            rpc_is_eis_format: res.data.data?.report_configuration.rpc_is_eis_format
              ? ["EIC Format"]
              : false,
            rpc_weighted_certno: res.data.data?.report_configuration.rpc_weighted_certno
              ? ["Weighted Certificate"]
              : false,

            rpc_is_sequence: res.data.data?.report_configuration.rpc_is_sequence
              ? ["Sequence"]
              : false,
            rpc_weight_avg_seq: res.data.data?.report_configuration.rpc_weight_avg_seq
              ? ["Sequence of the sections- Weighted Average"]
              : false,
            rpc_lotwise_seq: res.data.data?.report_configuration.rpc_lotwise_seq
              ? ["Sequence of the sections- Lot wise"]
              : false,
            rpc_sample_spec_seq: res.data.data?.report_configuration.rpc_sample_spec_seq
              ? ["Sequence of the sections- Sample Specifications"]
              : false,
            //new Added
            rpc_is_wt_sample_mark: res.data.data?.report_configuration.rpc_is_wt_sample_mark
              ? ["Client Sample Mark"]
              : false,
            rpc_is_annexure: res.data.data?.report_configuration.rpc_is_annexure
              ? ["Is Annexure"]
              : false,
            rpc_is_no_of_truck: res.data.data?.report_configuration.rpc_is_no_of_truck
              ? ["No. of Trucks"]
              : false,
            rpc_is_lotwise_lot_no: res.data.data?.report_configuration.rpc_is_lotwise_lot_no
              ? ["Lot No."]
              : false,
            rpc_is_smpl_sa_lowise: res.data.data?.report_configuration.rpc_is_smpl_sa_lowise
              ? ["Lot wise size analysis"]
              : false,
            rpc_is_sa_weighted_avg: res.data.data?.report_configuration.rpc_is_sa_weighted_avg
              ? ["Weighted Avg."]
              : false,
            rpc_is_other_remark: res.data.data?.report_configuration.rpc_is_other_remark
              ? ["Remark"]
              : false,
            rpc_is_other_work_dt: res.data.data?.report_configuration.rpc_is_other_work_dt
              ? ["Work Order & Dt."]
              : false,
            rpc_is_sequence_size_analysis: res.data.data?.report_configuration.rpc_is_sequence_size_analysis
              ? ["Size Analysis"]
              : false,
            // rpc_is_date_of_sample_receipt: res.data.data?.report_configuration?.rpc_sa_column_config?.rpc_is_date_of_sample_receipt
            //   ? ["Date of Sample Receipt"]
            //   : false,
            ...(() => {
              const saConfig = res.data.data?.report_configuration?.rpc_sa_column_config || {};
              const result = {};
              SA_COLUMN_CONFIG_FIELDS.forEach(({ formKey, configKey, label }) => {
                result[formKey] = saConfig[configKey] === true ? [label] : [];
              });
              return result;
            })(),
          },
          // 2: {
          //   ...prevFormData[2],
          //   ...(() => {
          //     const saConfig = res.data.data?.report_configuration?.rpc_sa_column_config || {};
          //     const result = {};
          //     SA_COLUMN_CONFIG_FIELDS.forEach(({ formKey, configKey, label }) => {
          //       result[formKey] = saConfig[configKey] === true ? [label] : [];
          //     });
          //     return result;
          //   })(),
          // },
        };
      });
    }, 10);

    const sequenceKeys = ["rpc_weight_avg_seq", "rpc_lotwise_seq", "rpc_sample_spec_seq"];
    const nameToBeAddedSequence = sequenceKeys
      .map(key => ({
        name: key,
        value: res.data.data?.report_configuration[key] // Get the value
      }))
      .filter(item => item.value !== undefined && item.value !== null && item.value !== -1) // Exclude empty, null, or -1
      .sort((a, b) => a.value - b.value)
      .map(item => item.name);
    setSequence(nameToBeAddedSequence);

  }
};

export const getCommercialCertificateSingle = async (
  EditRecordId,
  JISID,
  RPCID,
  setFormData,
  formData,
  formConfig,
  setIsOverlayLoader,
  TMLType,
  setNewExtraFields,
  isUseForPhysical
) => {
  let payload = {
    ji_id: EditRecordId,
    jis_id: JISID,
  };
  if (RPCID && RPCID !== "-999" && RPCID !== -999) {
    payload.cc_id = RPCID;
  }
  let res = await postDataFromApi(ccCertGetApi, payload);
  if (res.data.status === 200) {
    let extrafields = {}
    if (res?.data?.data?.cc_additional_headers) {
      let index = 0
      for (let obj in res?.data?.data?.cc_additional_headers) {
        const fieldName = "new_extra_field";
        extrafields[fieldName + '_label_' + index] = obj
        extrafields[fieldName + '_value_' + index] = res?.data?.data?.cc_additional_headers[obj]?.value
        extrafields[fieldName + '_chk_' + index] = res?.data?.data?.cc_additional_headers[obj]?.isChecked
        extrafields[fieldName + '_seq_' + index] = res?.data?.data?.cc_additional_headers[obj]?.seqNo || index
        index++
      }
      setNewExtraFields(index)
    }
    const additionaTypes = res?.data?.data.cc_additional_display_types
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const iscustomformatupload = decryptDataForURL(params.get("iscustomformatupload")) || formData[0]?.is_custom_format_upload;

    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        0: {
          ...prevFormData[0],
          ...res?.data?.data,
          ...res.data.data?.rpc_details,
          ...res?.data?.data?.cc_certijsondata,
          cert_number: res?.data?.data?.cc_certificatenumber,
          status: res?.data?.data?.status,
          ji_reference_number: res?.data?.data?.cc_refencenumber,
          ji_date: res?.data?.data?.cc_date,
          ji_sub_commodity_name: res?.data?.data?.cc_commodity,
          cc_accountof: res?.data?.data?.cc_accountof,
          cc_eia: res?.data?.data?.cc_eia,
          jrf_header: res?.data?.data?.cc_topheader,
          jrf_bottom: res?.data?.data?.cc_bottomheader,
          cc_show_rounded_qty: res?.data?.data?.cc_show_rounded_qty ? [true] : [],
          cc_is_hide_basis: res?.data?.data?.cc_is_hide_basis ? [true] : [],
          cc_is_qty_display: res?.data?.data?.cc_is_qty_display ? [true] : [],
          cc_is_rake_details: res?.data?.data?.cc_is_rake_details ? [true] : [],
          fk_commodityid: res?.data?.data?.commodity_details?.commodity_id,
          ji_is_supplier: res?.data?.data?.ji_is_supplier ? "Supplier" : "Buyer",
          operation_type_code: res?.data?.data?.operationmode?.ops_code,
          cc_place_of_work_name: res?.data?.data?.place_of_work?.pow_name,
          cc_is_other_format: res?.data?.data?.cc_is_other_format ? [true] : [],
          fk_cc_cert_format_label: res?.data?.data?.cc_cert_format_details?.client_certificate_format_code,
          rpc_weighted_certno: res?.data?.data?.cc_certijsondata?.rpc_weighted_certno ? [true] : [],
          cc_is_qty_label_display: res?.data?.data?.cc_certijsondata?.cc_is_qty_label_display ? [true] : [],
          cc_is_word_file: res?.data?.data?.cc_is_word_file ? "Yes" : "No",
          cc_is_custom_format_file: res?.data?.data?.cc_is_custom_format_file || iscustomformatupload ? "Yes" : "No",
          cc_appointed_qty_type: res?.data?.data?.cc_appointed_qty_type ? res?.data?.data?.cc_appointed_qty_type : "None",
          ...{
            cc_supp_buyer_type: additionaTypes?.cc_supp_buyer_type || "None",
            cc_place_of_work_type: additionaTypes?.cc_place_of_work_type || "None",
            cc_sub_commodity_type: additionaTypes?.cc_sub_commodity_type || "None",
            cc_vessel_name_type: additionaTypes?.cc_vessel_name_type || "None",
            cc_vessel_name: additionaTypes?.cc_vessel_name,
          },
          ...extrafields
        },
      };
    });
    if (getTruckOperations("OS") === res?.data?.data?.activity_code?.toLowerCase()) {
      let truckPayload = { ji_id: EditRecordId, jis_id: JISID };
      let truckRes = await postDataFromApi(getTruckSealingApi, truckPayload);
      if (truckRes?.data?.status === 200 && truckRes?.data?.data) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          0: {
            ...prevFormData[0],
            tr_os_remark: truckRes.data.data.tr_os_remark || "",
            tr_os_id: truckRes.data.data.tr_os_id,
          },
        }));
      }
    }
    if (getRakeCollectionActivity(1).includes(res?.data?.data?.activity_code.toLowerCase())) {
      getSingleQualityAnalysisData(
        JISID,
        formData,
        setIsOverlayLoader,
        setFormData,
        formConfig,
        EditRecordId,
        res?.data?.data?.fk_cert_config_id,
        isUseForPhysical,
        RPCID
      );
    }
  }
};

export const getCommercialCertificateTopBottom = async (setFormData, EditRecordId, OperationType, JISID, setNewExtraFields, fkConfigIDGL) => {
  let payload = {
    "ji_id": EditRecordId,
    "jis_id": JISID,
    "cert_config_id": fkConfigIDGL
  };
  // 1	"VL_QA"
  // 2	"VL_SV"
  // 3	"VL_HH"
  // 4	"VL_DS"
  // 5	"VL_TML"
  // 6	"VL_PSI"

  if ([getVesselOperation("QA"), getPlantOperations('VL')].includes(OperationType)) {
    payload.rhf_type = "QA"
    payload.rhf_id = 1
  }
  else if (OperationType === getVesselOperation("SV")) {
    payload.rhf_type = "SV"
    payload.rhf_id = 2

  }
  else if (OperationType === getVesselOperation("HH")) {
    payload.rhf_type = "HH"
    payload.rhf_id = 3
  } else if (OperationType === getVesselOperation("DS")) {
    payload.rhf_type = "DS"
    payload.rhf_id = 4
  }
  else if (OperationType === getVesselOperation("TML")) {
    payload.rhf_type = "TML"
    payload.rhf_id = 5
  }
  else if (OperationType === getVesselOperation("PSI")) {
    payload.rhf_type = "PSI"
    payload.rhf_id = 6
  }
  // else if (getVesselOperation().includes(OperationType)) {
  //   payload.rhf_type = "QA"
  //   payload.rhf_id = 1
  // }
  // Truck Related Changes ------------------------------------------------
  else if (OperationType === getTruckOperations("OS")) {
    payload.rhf_type = "tsr"
    payload.rhf_id = 7
  }

  else if (OperationType === getTruckOperations("CS")) {
    payload.rhf_type = "tcs"
    payload.rhf_id = 8
  }
  else if (OperationType === getTruckOperations("QS")) {
    payload.rhf_type = "tqa"
    payload.rhf_id = 9
  }
  else if (OperationType === getTruckOperations("DTM")) {
    payload.rhf_type = "tdtm"
    payload.rhf_id = 10
  }
  else if ([getStackOperations(), getPlantOperations('ST')].includes(OperationType)) {
    payload.rhf_type = "ST_QA"
    payload.rhf_id = 11
  }
  else if ([getTruckOperations(), getPlantOperations('TR')].includes(OperationType)) {
    payload.rhf_type = "TR_QA"
    payload.rhf_id = 12
  }
  else if ([getRakeOperations(), getPlantOperations('RK')].includes(OperationType)) {
    payload.rhf_type = "RK_QA"
    payload.rhf_id = 13
  }
  else if (OperationType === getVesselOperation('bulk_crg')) {
    payload.rhf_type = "VL_BC"
    payload.rhf_id = 14
  }
  else if (OperationType === getVesselOperation('VL_TML_M')) {
    payload.rhf_type = "VL_TML_M"
    payload.rhf_id = 15
  }
  else {
    payload.rhf_type = "QA"
    payload.rhf_id = 1
  }

  let res = await postDataFromApi(reportHeaderFooterCreateApi, payload);
  if (res.data.status === 200) {
    setTimeout(() => {
      setFormData((prevFormData) => {
        let extrafields = {}
        if (res?.data?.data?.additional_headers) {
          let index = 0
          for (let obj in res?.data?.data?.additional_headers) {
            const ischk = ["Date Of Receipt"].includes(obj)
            const fieldName = "new_extra_field";
            extrafields[fieldName + '_label_' + index] = obj
            extrafields[fieldName + '_value_' + index] = res?.data?.data?.additional_headers[obj]
            extrafields[fieldName + '_chk_' + index] = !ischk && res?.data?.data?.additional_headers[obj] ? true : false
            extrafields[fieldName + '_seq_' + index] = index + 1
            index++
          }
          setNewExtraFields(index)
        }
        let dsFieldOpt = []
        if (res?.data?.data?.draft_survey_formats) {
          dsFieldOpt = res?.data?.data?.draft_survey_formats?.available_formats?.map((dsType) => {
            return {
              "label": dsType,
              "value": dsType
            }
          })
        }
        if (OperationType === getVesselOperation("DS") && (!dsFieldOpt || dsFieldOpt?.length === 0)) {
          toast.error("No types available", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        return {
          ...prevFormData,
          0: {
            ...prevFormData[0],
            ...res?.data?.data,
            jrf_header: res?.data?.data?.header,
            jrf_bottom: res?.data?.data?.footer,
            ...extrafields,
            ds_options: dsFieldOpt
          },
        };
      });
    }, 1000)

  }
};

export const handleVesselOperationDelete = async (
  row,
  setIsDelete,
  getAllListingData,
  setPopupIndex
) => {
  let deleteBody = {
    "rpc_id": row?.rpc_id,
    "ji_id": row?.fk_jiid,
    "jis_id": row?.fk_jisid
  }
  let res = await deleteDataFromApi(reportConfigDeleteApi, deleteBody);

  if (res?.data?.status === 200) {
    toast.success(res.data.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsDelete(false);
  setPopupIndex(-1);
  getAllListingData();
};


export const handleDocumentDelete = async (
  row,
  setIsDelete,
  getAllListingData,
  setPopupIndex
) => {
  let deleteBody = {
    id: row.dl_id,
  }
  let res = await deleteDataFromApi(documentDeleteApi, deleteBody);

  if (res?.data?.status === 200) {
    toast.success(res.data.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsDelete(false);
  setPopupIndex(-1);
  getAllListingData();
};

export const handleCommonUploadFile = async (formData, fileUrl, setUploadPopup, EditGeneratedCertificate, JISID, OperationType, navigate, uploadedFile, isWordFile) => {
  // If "Is System Generated ?" is checked, send Word file to Word API, get PDF back, then upload PDF to S3
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const iscustomformatupload = decryptDataForURL(params.get("iscustomformatupload"));
  if (isWordFile === "Yes" && uploadedFile) {
    try {
      // Step 1: Send Word file to API to get PDF
      const wordFormData = new FormData();
      wordFormData.append('word_file', uploadedFile);
      wordFormData.append('cc_id', formData[0]?.cc_id);
      wordFormData.append('tenant', GetTenantDetails(1));
      wordFormData.append('iscustomformatupload', iscustomformatupload);

      const wordRes = await postDataFromApi(
        ccCertWordApi,
        wordFormData,
        "TRUE",
        true
      );

      if (wordRes?.status === 200 || wordRes?.status === 201) {
        // Step 2: Upload the received file to S3 via /masters/upload/
        const contentType = wordRes.headers?.['content-type'] || '';
        const isPdf = contentType.includes('application/pdf');
        const fileName = isPdf
          ? uploadedFile.name.replace(/\.(doc|docx)$/i, '.pdf')
          : uploadedFile.name.replace(/\.(doc)$/i, '.docx');
        const fileType = isPdf ? 'application/pdf' : contentType;
        const pdfFile = new File([wordRes.data], fileName, { type: fileType });
        const uploadFormData = new FormData();
        uploadFormData.append('file', pdfFile);
        uploadFormData.append('model_type', 'commercial_certificate');

        let uploadRes = await postDataFromApi(masterUploadApi, uploadFormData, "TRUE");

        if (uploadRes?.data?.status === 200) {
          fileUrl = uploadRes.data.data.file?.split('?')?.[0] || '';
        } else {
          toast.error(uploadRes?.data?.message || "PDF upload failed", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      } else {
        toast.error("Word file processing failed", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
    } catch (error) {
      console.error("Word API error:", error);
      toast.error(error?.response?.data?.message || "Error processing Word file", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
  }

  let folderPayload = {
    data: {
      // "fd_name": "27C2425A01VL0028"
      fd_name: formData[0]?.ji_reference_number,
    },
    parent_folder: "commercial_certificate",
  };
  let folderRes = await postDataFromApi(folderCreateApi, folderPayload);
  let FolderID;

  if (folderRes.data.status === 201 || folderRes.data.status === 200) {
    FolderID = folderRes?.data?.data.fd_id;
  } else {
    FolderID = folderRes?.data?.message?.existing_folder_id;
  }
  if (FolderID) {
    let payload = {
      data: {
        dl_folder: FolderID,
        // dl_sub_folder: 6,
        dl_module: "commercial_certificate",
        dl_document_name: formData[0].dl_document_name,
        dl_discription: formData[0].dl_discription,
        dl_document_reference: JISID,
        dl_document_jisid: JISID,
        dl_type: "Document Type",
        dl_show_to_all: true,
        dl_s3_url: fileUrl,
        dl_version: "1.0",
        dl_file_type: iscustomformatupload ? "Custom Formart Certificate" : "External Certificate",
        dl_date_uploaded: new Date(),
        dl_status: "Active",
        fk_cc_id: formData[0]?.cc_id
        // dl_assigned_to: "Assigned User",
        // document_type:"External Certificate",
        // doc_ref_id: JISID
      },
    };

    try {

      if (!formData[0].dl_document_name || !formData[0].dl_discription) {
        toast.error("Both 'Document Name' and 'Description' are required!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return; // Stop execution if either is missing
      }
      else {
        let documentResponse = await postDataFromApi(
          documentCreateApi,
          payload
        );
        if ([200, 201].includes(documentResponse?.data?.status)) {
          setUploadPopup(false);
          // generateCertificate("uploadedDocument", "posted", 1);
          if (formData[0]?.is_custom_format_upload) {
            let payload = {
              cc_id: formData[0]?.cc_id,
              commercial_certificate: {
                cc_is_word_file: true,
              },
            };
            let res = await putDataFromApi(ccUpdateApi, payload);
            if (res.data.status === 200) {
              navigate("/operation/commercial-certificate-list");
            }
          }
          else {
            EditGeneratedCertificate("posted", 1, '', iscustomformatupload);
          }


          setTimeout(() => {
            // navigate(
            //   `/operation/vessel-ji-list/vessel-list/commercial-certificate-preview/${encryptDataForURL(
            //     JISID
            //   )}/${encryptDataForURL(formData[0]?.cc_id)}` +
            //   "?OperationType=" +
            //   encryptDataForURL(OperationType) + "&isExternal=" + encryptDataForURL(1)
            // );
            toast.success(
              documentResponse.data?.message || "Document Created Successfully"
            );
          }, 250);
        }
      }
    } finally {
    }
  }
};
export const handleTransferCertificateOwnershipHandler = async (ccIds, customFormData, getAllListingData, setIsCustomPopup, clearbtnfunc, setIsOverlayLoader, moduleType) => {
  const fieldValue = moduleType === "internalcertificate" ? customFormData[0]?.fk_ic_certificate_transfered_to : customFormData[0]?.fk_certificate_transfered_to
  if (!fieldValue) {
    toast.error("Please select user", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    return
  }
  try {

    setIsOverlayLoader(true)
    let payload = {}
    let res
    if (moduleType === "internalcertificate") {
      payload = {
        bulkICIDs: ccIds,
        fk_ic_certificate_transfered_to: customFormData[0]?.fk_ic_certificate_transfered_to
      };
      res = await postDataFromApi(bulk_ic_update_to_trans_userAPI, payload);
    }
    else {
      payload = {
        bulkCCIDs: ccIds,
        fk_certificate_transfered_to: customFormData[0]?.fk_certificate_transfered_to
      };
      res = await postDataFromApi(bulk_cc_update_to_trans_userAPI, payload);
    }

    if (res.data.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      clearbtnfunc()
      getAllListingData();
    }
  }
  finally {
    setIsCustomPopup(false)
    setIsOverlayLoader(false)
  }
}

export const getConfigDatabyji_jis_id = async (ji_id, jis_id, setFormData, configCertStatusRPCID) => {
  try {
    let payload = {
      ji_id: ji_id,
      jis_id: jis_id,
      rpc_id: configCertStatusRPCID,
    };

    let res = await postDataFromApi(reportConfigGetApi, payload);
    if (res?.data.status === 200) {
      const rpc_is_other_remark = res?.data?.data?.report_configuration?.rpc_is_other_remark ? true : false
      setFormData((formdata) => {
        return {
          ...formdata,
          0: {
            ...formdata[0],
            rpc_is_other_remark: rpc_is_other_remark,
            rpc_is_wght_avg: res?.data?.data?.report_configuration.rpc_is_wght_avg,
            rpc_is_lotwise_wght_avg: res?.data?.data?.report_configuration.rpc_is_lotwise_wght_avg
          }
        }
      })
    }
  } catch (error) {
    console.error(error);
  }
};

export const handleCommercialCertDelete = async (
  cc_id,
  setIsDelete,
  getAllListingData,
  setPopupIndex,
  row
) => {
  try {
    let deleteBody = {
      cc_id: cc_id,
      is_non_lms: !getLMSOperationActivity().includes(getActivityCode(row?.activity_code).toLowerCase()) && !row?.cc_is_external
    };
    // console.log('ttt',deleteBody)
    // return
    let res = await postDataFromApi(ccCertDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }
  catch (e) {

  }
  finally {
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();

  }

};

export const handleConfigSave = async (type, formData, setIsOverlayLoader, sequence, EditSubRecordId, configCertStatus, EditRecordId, configCertStatusRPCID, setTabOpenSecond, setFormData) => {
  try {
    setIsOverlayLoader(true)
    const payload = {
      report_configuration: {
        // Weighted Average
        rpc_is_wght_avg: !!formData?.[1]?.rpc_is_wght_avg?.length,
        rpc_is_appendix: !!formData?.[1]?.rpc_is_appendix?.length,
        rpc_is_wt_sample_mark: !!formData?.[1]?.rpc_is_wt_sample_mark?.length,//new added
        rpc_is_annexure: !!formData?.[1]?.rpc_is_annexure?.length,//new added
        rpc_is_no_of_truck: !!formData?.[1]?.rpc_is_no_of_truck?.length,//new added

        // Lot-Wise
        rpc_is_lot_no: !!formData?.[1]?.rpc_is_lot_no?.length,
        rpc_is_lotwise_wght_avg: !!formData?.[1]?.rpc_is_lotwise_wght_avg?.length,
        rpc_is_lotwise_qty: !!formData?.[1]?.rpc_is_lotwise_qty?.length,
        rpc_is_lotwise_sample_qty: !!formData?.[1]?.rpc_is_lotwise_sample_qty?.length,
        rpc_is_lotwise_smpl_mark: !!formData?.[1]?.rpc_is_lotwise_smpl_mark?.length,
        rpc_is_lotwise_lot_no: !!formData?.[1]?.rpc_is_lotwise_lot_no?.length, //new added

        // Sample Specs
        rpc_is_sample_specs: !!formData?.[1]?.rpc_is_sample_specs?.length,
        rpc_is_smpl_spec_lotno: !!formData?.[1]?.rpc_is_smpl_spec_lotno?.length,
        rpc_is_qty: !!formData?.[1]?.rpc_is_qty?.length,
        rpc_is_smpl_mark: !!formData?.[1]?.rpc_is_smpl_mark?.length,
        rpc_is_dos: !!formData?.[1]?.rpc_is_dos?.length,
        rpc_is_smpl_qty: !!formData?.[1]?.rpc_is_smpl_qty?.length,
        rpc_is_smpl_wghtorunit: !!formData?.[1]?.rpc_is_smpl_wghtorunit?.length,
        rpc_is_smpl_type: !!formData?.[1]?.rpc_is_smpl_type?.length,

        // Size Analysis
        rpc_is_other_config: !!formData?.[1]?.rpc_is_other_config?.length,
        rpc_is_size_analysis: !!formData?.[1]?.rpc_is_size_analysis?.length,
        rpc_is_dual_port: !!formData?.[1]?.rpc_is_dual_port?.length,
        rpc_is_dual_port_combined: !!formData?.[1]?.rpc_is_dual_port_combined?.length,
        rpc_is_eis_format: !!formData?.[1]?.rpc_is_eis_format?.length,
        rpc_weighted_certno: !!formData?.[1]?.rpc_weighted_certno?.length,
        rpc_is_smpl_sa_lowise: !!formData?.[1]?.rpc_is_smpl_sa_lowise?.length, //New Added
        rpc_is_sa_weighted_avg: !!formData?.[1]?.rpc_is_sa_weighted_avg?.length, //New Added
        rpc_is_other_remark: !!formData?.[1]?.rpc_is_other_remark?.length, //New Added
        rpc_is_other_work_dt: !!formData?.[1]?.rpc_is_other_work_dt?.length, //New Added
        rpc_is_sequence_size_analysis: !!formData?.[1]?.rpc_is_sequence_size_analysis?.length, //New Added
        // rpc_is_date_of_sample_receipt: !!formData?.[1]?.rpc_is_date_of_sample_receipt?.length, //New Added


        // Other Selections
        rpc_is_sequence: !!formData?.[1]?.rpc_is_sequence?.length,
        rpc_weight_avg_seq: sequence.indexOf("rpc_weight_avg_seq") >= 0 ? sequence.indexOf("rpc_weight_avg_seq") + 1 : null,
        rpc_lotwise_seq: sequence.indexOf("rpc_lotwise_seq") >= 0 ? sequence.indexOf("rpc_lotwise_seq") + 1 : null,
        rpc_sample_spec_seq: sequence.indexOf("rpc_sample_spec_seq") >= 0 ? sequence.indexOf("rpc_sample_spec_seq") + 1 : null,

        // SA Column Config - all keys explicitly set, default false when formData[2] not populated
        rpc_sa_column_config: (() => {
          const saConfig = {};
          SA_COLUMN_CONFIG_FIELDS.forEach(({ formKey, configKey }) => {
            saConfig[configKey] = !!(formData?.[1] && formData[1][formKey]?.length);
          });
          // saConfig["rpc_is_date_of_sample_receipt"] = !!formData?.[1]?.rpc_is_date_of_sample_receipt?.length;
          return saConfig;
        })(),

        fk_jiid: formData[0]?.ji_id,
        fk_jisid: EditSubRecordId,
        status: configCertStatus,
        tenant: GetTenantDetails(1),
      },
    };

    let res;
    if (type === "Save") {
      res = await postDataFromApi(reportConfigCreateApi, payload);
    } else {
      payload.rpc_id = configCertStatusRPCID || formData[0]?.rpc_id;
      payload.ji_id = EditRecordId;
      payload.jis_id = EditSubRecordId;
      if (getCurrentRole() === "SU") {
        payload.is_regenerate = true
        payload.report_configuration.change_log_remark = formData[0]?.change_log_remark
      }
      res = await putDataFromApi(reportConfigUpdateApi, payload);
    }
    if (res?.data && res?.data?.status === 200) {
      setTabOpenSecond(true);
      if (type === "Save") {
        setFormData((prevFormData) => {
          return {
            ...prevFormData,
            0: {
              ...prevFormData[0],
              rpc_id: res.data.data?.rpc_id,
            },
          };
        });
      } else {
        setFormData((prevFormData) => {
          return {
            ...prevFormData,
            0: {
              ...prevFormData[0],
              temp_option_change: new Date(),
            },
          };
        });
      }

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }
  finally {
    setIsOverlayLoader(false)
  }
}

export const SA_COLUMN_CONFIG_FIELDS = [
  { formKey: "sa_lot_number", configKey: "lot_number", label: "Lot Number" },
  { formKey: "sa_quantity", configKey: "quantity", label: "Quantity (Qty In MT)" },
  { formKey: "sa_sample_mark", configKey: "sample_mark", label: "Sample Mark" },
  { formKey: "sa_jism_truck_no", configKey: "jism_truck_no", label: "Truck No" },
  { formKey: "sa_truck_mines", configKey: "truck_mines", label: "Mines" },
  { formKey: "sa_sample_loc", configKey: "sample_loc", label: "Sample Location" },
  { formKey: "sa_truck_supplier", configKey: "truck_supplier", label: "Supplier" },
  { formKey: "sa_truck_source", configKey: "truck_source", label: "Source" },
  { formKey: "sa_truck_transporter", configKey: "truck_transporter", label: "Transporter" },
  { formKey: "sa_truck_form_l_no", configKey: "truck_form_l_no", label: "Form L No" },
  { formKey: "sa_truck_no_of_truck", configKey: "truck_no_of_truck", label: "No. of Trucks" },
  { formKey: "sa_truck_gross_weight", configKey: "truck_gross_weight", label: "Gross Weight" },
  { formKey: "sa_tare_weight", configKey: "tare_weight", label: "Tare Weight" },
  { formKey: "sa_net_weight", configKey: "net_weight", label: "Net Weight" },
  { formKey: "sa_seal_number", configKey: "seal_number", label: "Seal No." },
  { formKey: "sa_seal_number_count", configKey: "seal_number_count", label: "Seal Count" },
  { formKey: "sa_sub_commodity", configKey: "sub_commodity", label: "Sub Commodity" },
  { formKey: "sa_jism_sampling_date", configKey: "jism_sampling_date", label: "Date of Sampling" },
  { formKey: "sa_jism_sampling_to_date", configKey: "jism_sampling_to_date", label: "Date of Sampling (To)" },
];

export const handleSAColumnConfigSave = async (type, formData, setIsOverlayLoader, EditSubRecordId, configCertStatus, EditRecordId, configCertStatusRPCID, setTabOpenSecond, setFormData) => {
  try {
    setIsOverlayLoader(true);

    const saColumnConfig = {};
    SA_COLUMN_CONFIG_FIELDS.forEach(({ formKey, configKey }) => {
      saColumnConfig[configKey] = !!formData?.[1]?.[formKey]?.length;
    });

    const payload = {
      report_configuration: {
        rpc_sa_column_config: saColumnConfig,
        fk_jiid: formData[0]?.ji_id,
        fk_jisid: EditSubRecordId,
        status: configCertStatus,
        tenant: GetTenantDetails(1),
      },
    };

    let res;
    if (type === "Save") {
      res = await postDataFromApi(reportConfigCreateApi, payload);
    } else {
      payload.rpc_id = configCertStatusRPCID || formData[0]?.rpc_id;
      payload.ji_id = EditRecordId;
      payload.jis_id = EditSubRecordId;
      if (getCurrentRole() === "SU") {
        payload.is_regenerate = true;
        payload.report_configuration.change_log_remark = formData[0]?.change_log_remark;
      }
      res = await putDataFromApi(reportConfigUpdateApi, payload);
    }

    if (res?.data && res?.data?.status === 200) {
      setTabOpenSecond(true);
      if (type === "Save") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          0: { ...prevFormData[0], rpc_id: res.data.data?.rpc_id },
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          0: { ...prevFormData[0], temp_option_change: new Date() },
        }));
      }
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } finally {
    setIsOverlayLoader(false);
  }
};

export const handleRegenerateCertificate = async (row, setIsOverlayLoader, getAllListingData) => {

  try {
    setIsOverlayLoader(true)
    const OperationType = getActivityCode(row?.activity_code).toLowerCase()
    let payload = {
      "dl_module": "commercial_certificate",
      "dl_document_reference": row?.fk_jiid,
      "is_active": true,
      "tenant": 1,
      fk_cc_id: row?.cc_id
    }
    let res = await postDataFromApi("/documents/list/", payload);
    if (res.data.status === 200) {
      const singleDoc = res.data.data?.find((singleDoc) => row?.cc_id == singleDoc.fk_cc_id)
      let payload, generateCertificateResponse;
      if (
        !getLMSOperationActivity().includes(getActivityCode(row?.activity_code).toLowerCase()) && ![getVesselOperation("bulk_crg"), getStackOperations("ST_SV"), getRakeOperations("RK_SV")].includes(getActivityCode(row.activity_code).toLowerCase())
      ) {
        let payload = {
          ji_id: row?.fk_jiid,
          jis_id: row?.fk_jisid,
          is_regenerate: true,
          tenant: 1,
        };
        let OPSDSRes = await getNonLMSDetailsById(getActivityCode(row.activity_code).toLowerCase(), payload);
        if (OPSDSRes.data.status === 200) {
          generateCertificateResponse = await downLoadNonLMSCertificatePDFById(
            getActivityCode(row?.activity_code).toLowerCase(),
            OPSDSRes?.data?.data?.opsvd_id,
            row?.cc_id,
            "",
            row?.fk_jisid,
            true
          );
        }
      } else {
        payload = {
          ji_id: row?.fk_jiid,
          cc_id: row?.cc_id,
          is_regenerate: true,
          is_ocr: true
        };
        if (row?.cc_is_physical) {
          generateCertificateResponse = await postDataFromApi(physicalAnalysisPDF, payload, "", true, "", "");
        }
        else if (OperationType == getTruckOperations("DTM")) {
          generateCertificateResponse = await postDataFromApi(truckQAPdfApi, payload, "", true, "", "");
        }
        else if ([getPlantOperations("TR"), getTruckOperations("QS")].includes(OperationType)) {
          generateCertificateResponse = await postDataFromApi(truckQA2PdfApi, payload, "", true, "", "");
        }
        else if ([getPlantOperations("RK"), getRakeOperations('QA')].includes(OperationType)) {
          generateCertificateResponse = await postDataFromApi(rakeQAPdfApi, payload, "", true, "", "");
        }
        else if (OperationType == getTruckOperations('CS')) {
          generateCertificateResponse = await postDataFromApi(truckCSPdfApi, payload, "", true, "", "");
        }
        else if (OperationType == getStackOperations("PV") || OperationType == getStackOperations()) {
          generateCertificateResponse = await postDataFromApi(stackQAPdfApi, payload, "", true, "", "");
        }
        else if (OperationType == getVesselOperation('CS')) {
          generateCertificateResponse = await postDataFromApi(truckCSPdfApi, payload, "", true, "", "");
        }
        else if (OperationType == getVesselOperation('bulk_crg')) {
          generateCertificateResponse = await postDataFromApi(bulkCargoPDF, payload, "", true, "", "");
        }
        else if (OperationType == getVesselOperation('VL_TML_M')) {
          generateCertificateResponse = await postDataFromApi(tmlMoisturePDFApi, payload, "", true, "", "");
        }
        else if (OperationType == getRakeOperations('RK_SV')) {
          payload.jis_id = row?.fk_jisid
          generateCertificateResponse = await postDataFromApi(opsRakeSVPDFApi, payload, "", true, "", "");
        }
        else if (OperationType == getStackOperations('ST_SV')) {
          payload.jis_id = row?.fk_jisid
          generateCertificateResponse = await postDataFromApi(opsStackSVPDFApi, payload, "", true, "", "");
        }
        else {
          payload = {
            ...payload,
            is_ocr: true
          }
          generateCertificateResponse = await postDataFromApi(ccCertPdfApi, payload, "", true, "", "");

        }
      }

      if (
        generateCertificateResponse &&
        generateCertificateResponse.data &&
        generateCertificateResponse.data.status === 200
      ) {
        const pdfBlob = new Blob([generateCertificateResponse.data], {
          type: "application/pdf",
        });
        let payload = new FormData();
        payload.append("document", pdfBlob, (row?.activity + "_" + row?.cc_certificatenumber + ".pdf") || "certificate.pdf");
        payload.append("model_type ", "commercial_certificate");
        payload.append("bypass_file_size_check ", true);
        payload.append("sub_folder", 6);
        let uploadResponse = await postDataFromApi(
          masterUploadApi,
          payload,
          "TRUE"
        );
        if (uploadResponse.data.status === 200) {
          const count = singleDoc.dl_old_s3_urls ? Object.keys(singleDoc.dl_old_s3_urls).length + 1 : 0;
          let oldHardCopy = {}
          if (singleDoc.dl_cc_hard_copy_s3_url) {
            const count2 = Object.keys(singleDoc.dl_cc_hard_copy_old_s3_urls).length + 1;
            oldHardCopy = {
              ...singleDoc.dl_cc_hard_copy_old_s3_urls,
              [`v${count2}`]: singleDoc.dl_cc_hard_copy_s3_url?.split('?')?.[0] || ''
            }
          }
          const payload = {
            id: singleDoc.dl_id,
            is_regenerate: true,
            data: {
              dl_s3_url: uploadResponse.data?.data?.document?.split('?')?.[0] || '',
              dl_old_s3_urls: {
                ...singleDoc.dl_old_s3_urls,
                [`v${count}`]: singleDoc.dl_s3_url?.split('?')?.[0] || ''
              },
              dl_cc_hard_copy_s3_url: "",
              dl_cc_hard_copy_old_s3_urls: oldHardCopy
            },
          };
          let documentResponse = await putDataFromApi(documentUpdate, payload);
          if (documentResponse.data.status === 200) {
            toast.success('Successfully Re-Generated', {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            getAllListingData()
          } else {
          }
        } else {
          toast.error(
            uploadResponse?.message ||
            uploadResponse?.data?.message ||
            'An unexpected error has occurred.',
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }
      } else {
        toast.error(
          generateCertificateResponse?.message ||
          generateCertificateResponse?.data?.message || 'An unexpected error has occurred.',
          {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    }
  }
  finally {
    setIsOverlayLoader(false)
  }
}

export const handleDeleteCustomFormatCertificate = async (row, getAllListingData, setIsOverlayLoader) => {
  try {
    setIsOverlayLoader(true)
    let payload = {
      cc_id: row.cc_id,
      commercial_certificate: {
        cc_is_custom_format_file: false
      }
    }
    let res = await putDataFromApi(ccUpdateApi, payload);
    if (res.data.status === 200) {
      let payload = {
        dl_module: "commercial_certificate",
        dl_document_reference: row.fk_jisid,
        dl_document_jisid: row?.fk_jisid,
        is_active: true,
        tenant: 1,
        "fk_cc_id": row?.cc_id,
      };
      res = await postDataFromApi("/documents/list/", payload);
      if (res.data.status === 200) {
        const dl_id = res.data.data[0].dl_id;
        let payload = {
          "id": dl_id
        }
        res = await deleteDataFromApi(documentDeleteApi, payload);
        if (res.data.status === 200) {
          getAllListingData();
        }
      }
    }
  } catch (error) {
    console.log('rrrrr', error)
  }
  finally {
    setIsOverlayLoader(false)
  }
}